<template>
  <b-card no-body>
    <b-card-header class="pb-50">
      <h5>
        Import Data
      </h5>
    </b-card-header>
    <b-card-body>
      <b-row>
        <b-col
          cols="12"
          md="4"
          class="mb-md-0 mb-2"
        >
          <label>Import File Peserta</label>
          <b-form-file
            v-model="fileUpload"
            placeholder="Choose a file or drop it here..."
            drop-placeholder="Drop file here..."
          ></b-form-file>
        </b-col>
        <b-col
          cols="12"
          md="4"
          class="mb-md-0 mb-2 mt-2"
        >
        <div class="d-flex">
          <b-button variant="primary" @click="upload()" :disabled="loaderShow == true">Submit</b-button>
          <b-button class="ml-1" variant="primary" @click="downloadTemplate()" :disabled="loaderShow == true">Download Template</b-button>
        </div>
        </b-col>
        <b-col
          cols="12"
          md="4"
          class="mb-md-0 mb-2 mt-2"
        >
        <div class="d-flex">
          <b-spinner label="Spinning" v-if="loaderShow == true"></b-spinner>
        </div>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BRow, BCol, BFormInput,BButton,BFormFile,BSpinner,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import {
  downloadTemplatePeserta,
  uploadFileImportPeserta,
} from '@/connection-api/master'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    vSelect,
    BFormInput,
    BButton,
    BFormFile,
    BSpinner,
  },
  data() {
    return {
      filter: {},
      count: 0,
      fileUpload: null,
      loaderShow: false,
    }
  },
  methods: {
    async downloadTemplate(){
      const result = await downloadTemplatePeserta();
      const blob = new Blob([result.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }); // XLSX MIME type
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      const date = new Date().toLocaleString(['ban', 'id']);
      const filename = `template-${date}.xlsx`.replace(/[^a-z0-9_.-]/gi, '_'); // replaces invalid characters
      link.download = filename;
      link.href = url;

      document.body.appendChild(link);
      link.click();

      // Clean up
      link.remove();
      window.URL.revokeObjectURL(url)
    },
    makeToast(variant = null, message = null, title = null) {
      this.$bvToast.toast(message, {
        title: 'Import Peserta',
        variant,
        solid: true,
        autoHideDelay: 10000,
        enableHtml: true,
        allowHtml: true,
      })
    },
    upload(){
        if(this.fileUpload != null)
        {
          this.loaderShow = true
          uploadFileImportPeserta(this.fileUpload, 'user', event => {
          var progress = Math.round((100 * event.loaded) / event.total)
        })
          .then(response => {
            if(response.data.success == true)
            {
              this.loaderShow = false
              this.makeToast('success', 'Data berhasil diupload')
              this.$emit('refetchData')
            } else {
              this.loaderShow = false
              this.makeToast('danger', response.data.status.message)
            }
          })
        .catch(error => {
          console.log(error)
          this.loaderShow = false
        });
      }
    },
    cari()
    {
      this.count += 1
      this.$emit('update:dataFilter', this.filter)
      this.$emit('update:triggerFilter', this.count)
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
